import {
    Modal,
    Paper,
    Typography,
    Button,
    CircularProgress,
    Box,
    IconButton
} from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { ImagePaths } from '../../Utility/ImagePaths';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import { localGetItem } from '../../Utility/Services/CacheProviderService';
import { Colors } from '../../Styles/Colors';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


const AICollabSummary = ({ ClosePopUp, PatientData, errorMessage, saveAICollabData, AICollabData }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [responseData, setResponseData] = useState(null);

    useEffect(() => {
        if (AICollabData) {
            setIsLoading(false)
            setResponseData(AICollabData)
        } else {
            getCollabData()
        }
    }, []);

    const getCollabData = () => {
        try {
            setIsLoading(true)
            let data = {
                patient_id: PatientData?.patient_id || null,
                doctor_id: PatientData?.doctor_id || null,
                appointment_id: PatientData?.appointment_id || null,
                clinic_id:  (localGetItem("SelectedDoctorClinicId")) ? + (localGetItem("SelectedDoctorClinicId")) : null,
                time_stamp: new Date().toISOString()
            }
            RestAPIService.create(data, Serviceurls.AI_COLLAB_SUMMARY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setIsLoading(false)
                        setResponseData(response.data.data || null)
                        saveAICollabData(response.data.data || null)
                    }
                }).catch(e => {
                    setIsLoading(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const handleClose = () => {
        ClosePopUp();
    };

    return (
        <Modal open={true} onClose={handleClose}>
            <Paper elevation={3} sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%',
                Width: "30dvw",
                p: 3,
                outline: 'none',
                textAlign: 'center',
                height: '80dvh',
            }}>
                <Box sx={{ display: "flex", justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AutoAwesomeIcon fontSize='small' />
                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                            AI Generated Collaborative Summary
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: "center", }}>
                        <Button variant='contained' size='small' sx={{ textTransform: "capitalize", marginRight:"2vw" }} onClick={() => getCollabData()}>Regenerate</Button>
                        <IconButton color="primary" curser="pointer" onClick={() => handleClose()} >
                            <img style={{ width: '2vw', height: '2vh' }} src={ImagePaths.Close.default} alt='close' />
                        </IconButton>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center', height: "70dvh", overflow: "auto" }}>
                    {isLoading ? <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <img style={{ height: "40vh", width: "20vw", marginTop: '2dvw', marginBottom: "-5dvw" }} src={ImagePaths.AiCollab.default} />
                        <Typography color={Colors.ThemeColor}>Analysing data...</Typography>
                    </Box> : <Box sx={{ height: "70dvh", whiteSpace: 'balance' }} dangerouslySetInnerHTML={{ __html: responseData }} />
                    }
                </Box>
            </Paper>
        </Modal >
    );
};

export default AICollabSummary;
